exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n#gladlyChat_container .EndMessage__endMessage___3_S5k {\n  color: #111111 !important;\n  font-size: 14px !important;\n  line-height: 19px !important;\n  margin: auto !important;\n  text-align: center !important;\n  width: 336px !important;\n  word-wrap: break-word !important;\n}\n\n#gladlyChat_container .EndMessage__endMessage_container___2xmic {\n  -ms-flex-item-align: center !important;\n      align-self: center !important;\n}\n\n#gladlyChat_container .EndMessage__endMessage_title___1rpa0 {\n  font-weight: bold !important;\n}", ""]);

// exports
exports.locals = {
	"endMessage": "EndMessage__endMessage___3_S5k",
	"endMessage_container": "EndMessage__endMessage_container___2xmic",
	"endMessage_title": "EndMessage__endMessage_title___1rpa0"
};